export default __webpack_public_path__ + "static/media/handleAndStrapYellow_diffuse-min.f1b67fe3.jpg";